var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasLoader512X512L(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pas_loader_512x512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pas_loader_512x512-u-backup",
    transform: "translate(-.044048 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "pas_loader_512x512-u-3",
    x1: 0,
    y1: -188.88952,
    x2: 0,
    y2: 181.087465,
    transform: "matrix(1 0 0-.706924 60.044048 266.469447)",
    fill: "none",
    stroke: "#d8dfe1",
    strokeWidth: 60,
    strokeDashoffset: 372.965439,
    strokeDasharray: 372.965439
  }), /*#__PURE__*/React.createElement("line", {
    id: "pas_loader_512x512-u-1",
    x1: 0,
    y1: -186.530081,
    x2: 0,
    y2: 72.453808,
    transform: "matrix(-1 0 0 0.648689 370.044048 402.999989)",
    fill: "none",
    stroke: "#d8dfe1",
    strokeWidth: 60,
    strokeDashoffset: 372.965439,
    strokeDasharray: 372.965439
  }), /*#__PURE__*/React.createElement("line", {
    id: "pas_loader_512x512-u-2",
    x1: 0,
    y1: -134.886434,
    x2: 0,
    y2: 167.99413,
    transform: "matrix(0-1-1.053075 0 206.954468 420)",
    fill: "none",
    stroke: "#d8dfe1",
    strokeWidth: 60,
    strokeDashoffset: 305.987315,
    strokeDasharray: 305.987315
  }), /*#__PURE__*/React.createElement("line", {
    id: "pas_loader_512x512-u-4",
    x1: 0,
    y1: -226.213287,
    x2: -0.000014,
    y2: 36.344123,
    transform: "matrix(0-1 0.997877 0 255.777084 120)",
    fill: "none",
    stroke: "#d8dfe1",
    strokeWidth: 60,
    strokeDashoffset: 262.972616,
    strokeDasharray: 262.972616
  }), /*#__PURE__*/React.createElement("line", {
    id: "pas_loader_512x512-u-5",
    x1: -30.162458,
    y1: -21.782652,
    x2: 59.58573,
    y2: 67.588443,
    transform: "translate(174.810389 271.387324)",
    fill: "none",
    stroke: "#41cae7",
    strokeWidth: 60,
    strokeDashoffset: 126.65674,
    strokeDasharray: 126.65674
  }), /*#__PURE__*/React.createElement("line", {
    id: "pas_loader_512x512-u-6",
    x1: -152.491299,
    y1: -143.597506,
    x2: 104.984127,
    y2: 112.79609,
    transform: "matrix(0-1 1 0 336.515551 186.689033)",
    fill: "none",
    stroke: "#41cae7",
    strokeWidth: 60,
    strokeDashoffset: 363.361075,
    strokeDasharray: 363.361075
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasLoader512X512L);
export default __webpack_public_path__ + "static/media/pas_loader_512x512_L.c3e273e5ee30ba35bcc04425c78b581f.svg";
export { ForwardRef as ReactComponent };